<template>
<div :class="wide_form?'container_fluid':'container'">

    <v-app>
    <v-card >
        <v-card-title  class="headline">{{ title }}</v-card-title>
        <v-card-text >
            <errors :errors="errors" />
            <pre v-if="log" v-for="l in log">{{ l }}</pre>

            <v-row >
                <v-col cols="2">
                    <div v-for="t of times" v-if="times && times.length">
                        <a href="" @click.prevent="set_record(t)" :class="{'active':t && cur_record && t.id==cur_record.id}">{{ t.registered }}</a>
                    </div>
                </v-col>
                <!-- [loading...] -->


                <v-col cols="10" >
                    <v-progress-linear
                        color="primary"
                        indeterminate
                        rounded
                        height="6"
                        v-if="loading"
                    />
                    <h2 v-if="cur_record">{{ cur_record.name }} - {{ cur_record.registered }}</h2>
                    <table class="tbl1" v-if="cur_record && cur_record.values">
                        <tr class="h">
                            <td>Название поля</td>
                            <td>Старое значение</td>
                            <td>Новое значение</td>
                        </tr>
                        <tr v-for="f in fields" :class="{changed: (next_record && cur_record) && cur_record.values[f.name] != next_record.values[f.name]}">
                            <td>{{ f.description }}</td>
                            <td v-if="cur_record && cur_record.values">{{ cur_record.values[f.name] }}</td>
                            <td v-if="next_record">
                                <template v-if="next_record && next_record.values">
                                    {{ next_record.values[f.name] }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                                
                            </td>
                            
                        </tr>
                    </table>
                </v-col>
                
            </v-row>
        </v-card-text>
    </v-card>
    </v-app>
</div>
</template>
<script>
export default {
    props:['params'],
    data(){
        return {
            tab: '',
            title:'',
            wide_form: true,
            log:null,
            errors:[],
            history_hash:{},
            cur_record:null,
            next_record:null,
            last_record:null, // когда next_record в истории отсутствует, last_record берём из текущих значений
            times: null,
            fields:[],
            loading:0

        }
    },
    methods:{
        load_values(record, varname){
            let t=this
            
            t.loading++
            t.$http.get(`${BackendBase}/history/${t.params.config}/${t.params.id}/${record.id}`).then(
                r=>{
                    let d=r.data
                    t.loading-- 
                    if(d.success){
                        
                        record['values']=d.values
                        if(varname=='last_record'){
                            t['next_record']=record
                        }
                        else{
                            t[varname]=record
                        }
                    }
                }
            )

        },
        set_record(record){ // делаем активной запись
            let t=this
            //console.log('set_record:',record)
            
            t.load_values(record,'cur_record')

            history.pushState({  }, `${record.registered} - ${record.name}`, `?record_id=${record.id || ''}`)

            if(record.next_id){
                let next_record=null
                for(let time of t.times){
                    if(time.id==record.next_id){
                        next_record=time
                    }
                }
                if(next_record){

                    t.load_values(next_record, 'next_record')
                }
                else{
                    
                    
                }
                
                
            }
            else{
                t.next_record=null
                t.load_values({id:0}, 'last_record')
            }
        },
        init(){
            let t=this
            t.loading++
            t.$http.get(`${BackendBase}/history/${t.params.config}/${t.params.id}`).then(
                r=>{
                    let d=r.data
                    t.errors=d.errors
                    t.title=d.title
                    t.log=d.log
                    t.loading--
                    if(d.success){
                        t.fields=d.fields
                        t.times=d.times
                        let cur_time=null
                        if(t.times.length){
                            
                            if(/^\?record_id=\d+$/.test(location.search)){
                                let record_id=parseInt(location.search.replace('?record_id=',''))
                                
                                for(let time of t.times){
                                    if(time.id==record_id){
                                        cur_time=time
                                        break
                                    }
                                }
                                
                            }   
                            if(cur_time){
                                t.set_record(cur_time)
                            }
                            else{
                                t.set_record(t.times[0])
                            }
                            
                            
                            
                            
                            
                        }
                    }
                }
            )
        }
    },  
    created(){
        
        this.init()
    }
}
</script>
<style scoped>
    a.active {font-weight: bold;}
    .changed {background: #ff620061 !important;}
</style>